<template>
	<footer v-if="showFrame">
		<iframe src="https://www.tunnelling.cn/footer.aspx" width="100%" height="810" scrolling="no" frameborder="0" ref="myiframe"></iframe>
	</footer>
	<footer v-else>
	    <div class="f_aboutus">隧道网（www.tunnelling.cn）是隧道行业最具影响力的行业门户网站之一，集行业媒体、技术交流、软件服务等多种服务属性于一体，搭建隧道人士交流与合作的平台。</div>
	    <div class="f_contactus"><img src="../assets/img/qrcode.jpg" alt="">上海市徐汇区虹漕南路155号 5楼<br>
	    电话：021-64225589 <br>
	    传真：021-54640607<br>
	    电邮：website@tunnelling.cn</div>
	</footer>
</template>

<script>
export default{
	data(){
		return{
			showFrame:true
		}
	},
	mounted() {
		// 判断加载哪个dom
		let wid = window.innerWidth;
		if(wid>=320&&wid<=1024){
			this.showFrame = false;
			return;
		}
		// this.changeFrameHeight();  
		
	},
	methods:{
		changeFrameHeight(){
			var ifm = this.$refs.myiframe;
		    ifm.height=document.documentElement.clientHeight;
		}
	}
}
</script>

<style scoped>
@media screen and (min-width: 320px) and (max-width: 1024px){
	footer{
		margin-top: 25px;
	}
}
.f_aboutus {
    font-size: 1.3em;
    line-height: 20px;
    color: #696969;
    background-color: #e8e8e8;
    padding: 10px;
}
.f_contactus {
    font-size: 1.3em;
    line-height: 20px;
    color: #fff;
    background-color: #0078d7;
    padding: 10px;
    padding-bottom: 60px;
}
.f_contactus img {
    float: right;
    width: 78px !important;
    height: auto;
}
.f_contactus:after {
    content: "";
    clear: both;
    display: block;
    font-size: 0;
    height: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/BottomFooter.vue